import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import { dropSegments, fetchSegments } from 'common/filter/actions/segmentsActions'

interface EnsureSegmentsControllerProps {
  loader: React.ReactElement
  children: React.ReactElement
}

const EnsureSegmentsController = ({ children, loader }: EnsureSegmentsControllerProps) => {
  const { items } = useAppSelector((state) => state.segments)

  const dispatch = useAppDispatch()

  useEffect(() => {
    const updateSegments = async () => {
      await dispatch(dropSegments())
      await dispatch(fetchSegments())
    }

    updateSegments()
  }, [dispatch])

  if (items === null) {
    if (loader) {
      return loader
    }
    return null
  }
  return children
}

export default EnsureSegmentsController
